import { Component, Fragment } from "react";
import { Row, Col } from "react-flexbox-grid";
import PropTypes from "prop-types";
import Fetch from "utils/fetch";

import intl from "react-intl-universal"
import { SelectBox, SnackBar, ToggleTwo } from "components/uikit-adapter/index";
import GenericModal from "components/generic-modal";
import Button from "components/button";

import Loading from "components/center-loading";
import StyledForm from "./styledForm";

import {
  searchWallets,
  searchFamilies,
  searchLabeledFamilies,
  searchCenters,
  searchCoordination,
  searchPeriodicidadeList,
  searchTipoAlgoritmoList,
  searchSaneamentoVolumesPendentes,
  searchPilotoAutomatico,
  searchAcionamentoTransporteCIF,
  buscarFamiliaRotuladaCentro,
  featureFlagDynamicInventoryPolicy,
  featureFlagDoiDynamicInventoryPolicy,
  searchDynamicInventoryPolicy,
  searchLabeledFamilyCenterMaterialByLabeledFamilyId
} from "./general-form.service";
import InventoryConfiguration, { STOCK_POLICY, INVENTORY_POLICY_MODEL, mapInventoryPolicyModelToStockPolicy } from "./components/inventory-configuration";
import { validaReplanejamentosPedidosDX, verifyStoragesHasSomePolicyError, verifyAllStorageLocationsHasLines } from "./validations";
import { getValueForCondition, validatesArrayHasValue } from "utils/custom-functions";
import { Switcher } from "components/toggle";
import { SwitcherTwo } from "components/toggle-2";
import { formatOnlyNumber } from "utils/format";
import { parseFloatByLocale } from "locales/utils";
import { hideSomeSettingsLabeledFamily, isLoadCompositionFlowBrewerySide, usesHourlyPlan, usesOORRelevance, usesTmsIntegration, usesVolume } from "utils/validations-general-settings";
import Feature from "components/feature";
import SessionUser from 'utils/user-storage'
import TipoPerfilAcesso from "models/usuarios/tipo-perfil-acesso";
import { formatErrorMessage } from "utils/handle-error";
import StorageLocationAndLineConfiguration from "./components/storage-location-and-line-configuration";
import { getProductionLineByCenter, searchBusinessUnitById } from "services/business-unit.service";
import InventoryConfigurationByStorageLocation from "./components/inventory-configuration-by-storage-location";
import { mapperInventoryStorageLocations, mapperStorageLocationsProductionLines, mountLabeledFamilyCenterBusinessUnitStorageLocations } from "./utils";
import Input from "components/input";

const TIPO_ALGORITMO_POLITICA_OBJECTIVA = 1
const TIPO_ALGORITMO_POLITICA_SILOS = 3

const PERIODICIDADE_MENSAL = 1
const PERIODICIDADE_DIARIA = 2

const INTL_GERAL = 'master-data.general-configuration';

class GeneralForm extends Component {
  constructor() {
    super();
    this.state = {
      _isMounted: false,
      labeledFamily: {},
      families: [],
      wallets: [],
      labeledFamilies: [],
      centers: [],
      coordinations: [],
      selectedWallet: "",
      selectedFamily: "",
      selectedLabeledFamily: "",
      selectedCenter: "",
      selectedCoordination: [],
      selectedPeriodicidade: "",
      selectedSaneamentoVolumesPendentes: true,
      selectedReplanejamentoDataEntrega: false,
      selectedCreateChargeCompositionAutomatic: false,
      selectedExternalSuggestion: false,
      selectedUseHourlyPlan: false,
      selectedFutureNeed: false,
      selectedReschedulingOrderByCapacity: false,
      selectedPilotoAutomatico: false,
      selectedDeliveryAutomaticRefresh: false,
      selectedAcionamentoTransporteCIF: false,
      selectedLoadMixReleasedRefresh: false,
      selectedOORRelevance: false,
      selectedSaneamentoPedidos: false,
      selectedBreakInFullTruck: false,
      selectedNegotiateLoadCompositions: false,
      periodicidades: [],
      selectedTipoAlgoritmo: "",
      tiposAlgoritmo: [],
      isFetching: false,
      showMsg: false,
      textMsg: "",
      idPeriodicidadeFamiliaRotulada: "",
      saneamentoVolumesPendentesFamiliaRotulada: null,
      pilotoAutomaticoFamiliaRotulada: null,
      acionamentoTransporteCIFFamiliaRotulada: null,
      relevanciaOORFamiliaRotulada: null,
      isDailyWallet: true,
      campoPercentual: null,
      selectedAutopilotScheduleType: "",
      selectedUseStorageLocations: false,
      selectedUseDynamicInventoryPolicies: false,
      featureFlagDynamicInventoryPolicy: false,
      featureFlagDoiDynamicInventoryPolicy: false,
      selectedCurrentStockPolicy: STOCK_POLICY.OBJECTIVE,
      storageLocationsProductionLines: [],
      businessUnit: {},
      inventoryStorageLocations: [],
      materialId: null
    };
  }

  componentDidMount() {
    this.setState({ _isMounted: true });
    const editMode = this.props.editMode;

    if (editMode) {
      this.buscarFamiliaRotuladaCentro(this.props.idEdit);
    } else {
      if (usesVolume() && isLoadCompositionFlowBrewerySide()) this.setState({ selectedLoadMixReleasedRefresh: true });
      this.searchWallets();
    }

    this.searchCoordination();
    this.searchPeriodicidadeList();
    this.searchTipoAlgoritmoList();
    this.searchFeatureFlagDynamicInventoryPolicy();
    this.searchFeatureFlagDoiDynamicInventoryPolicy();
  }

  componentWillUnmount() {
    this.setState({ _isMounted: false });
  }

  startFetching = () => {
    this.setState({
      isFetching: true
    });
  };

  stopFetching = () => {
    this.setState({
      isFetching: false
    });
  };

  userCanEditStockPolicies = () => {
    const editableUserProfiles = [
      TipoPerfilAcesso.Gestor,
      TipoPerfilAcesso.MasterData,
      TipoPerfilAcesso.Administrador
    ]
    return editableUserProfiles.includes(SessionUser.get().PerfilAcesso);
  }

  mountInventories = (storages) => {
    if(!validatesArrayHasValue(storages)) return [];

    return storages.map(x => ({
      StorageLocationId: x.Id,
      Description: x.StorageLocation,
      LabeledFamilyCenterBusinessUnitStorageLocationsId: 0,
      CurrentMaximumStock: 0,
      CurrentMinimumStock: 0,
      CurrentRefuelingPoint: 0,
      CurrentRefuelingPointPercent: 0
    }));
  }

  buscarFamiliaRotuladaCentro = async () => {
    try {
      const data = await buscarFamiliaRotuladaCentro(this.props.idEdit);
      const businessUnitData = await searchBusinessUnitById(data.BusinessUnitId);
      const productionLines = await getProductionLineByCenter(businessUnitData.Centro);
      
      this.setState({
        labeledFamily: {
          ...data,
          DataInicioPoliticaEstoqueFuturo: data.FutureStockPolicyStartDate
            ? new Date(data.FutureStockPolicyStartDate)
            : null,
          EstoqueMinimoAtual: data.CurrentMinimumStock,
          EstoqueMaximoAtual: data.CurrentMaximumStock,
          PontoReabastecimentoAtual: data.StockPolicyTypeId == TIPO_ALGORITMO_POLITICA_SILOS
            ? data.CurrentMaximumStock
            : data.CurrentRefuelingPoint,
          orderSanitation: data.NumberOfDaysToProcessOrders,
          HorizonteProgramacao: data.ProgrammingHorizon,
          ReplanejamentoPedidosDX: data.ReplanningOrdersDX,
          Centro: data.Destination,
          FamiliaRotulada: data.LabeledFamily,
          Familia: data.Family,
          Carteira: data.MaterialGroup,
          DoiMinimum: data.DoiMinimum ?? null,
          DoiTarget: data.DoiTarget ?? null,
          DoiMaximum: data.DoiMaximum ?? null,
          DoiFloor: data.DoiFloor ?? null,
        },
        campoPercentual: Math.ceil(data.CurrentRefuelingPointPercent),
        familyId: data.Id,
        selectedWallet: data.MaterialGroupId,
        selectedFamily: data.FamilyId,
        selectedLabeledFamily: data.LabeledFamilyId,
        selectedCoordination: data.Coordinations,
        selectedCenter: data.BusinessUnitId,
        selectedPeriodicidade: data.PeriodicityId,
        idPeriodicidadeFamiliaRotulada: data.LabeledFamilyPeriodicityId,
        saneamentoVolumesPendentesFamiliaRotulada: data.LabeledFamilySanitationPendingVolumes,
        pilotoAutomaticoFamiliaRotulada: data.LabeledFamilyAutopilot,
        acionamentoTransporteCIFFamiliaRotulada: data.LabeledFamilyTransportDriveCIF,
        selectedTipoAlgoritmo: data.StockPolicyTypeId,
        selectedSaneamentoVolumesPendentes: data.SanitationPendingVolumes,
        selectedReplanejamentoDataEntrega: data.ReplanningDeliveryDate,
        selectedCreateChargeCompositionAutomatic: data.CreateAutomaticLoadComposition,
        selectedExternalSuggestion: data.ExternalSuggestion,
        selectedUseHourlyPlan: data.UseHourlyPlan,
        selectedFutureNeed: data.FutureNeed,
        selectedReschedulingOrderByCapacity: data.ReschedulingOrderByCapacity,
        selectedPilotoAutomatico: data.Autopilot,
        selectedAcionamentoTransporteCIF: data.TransportDriveCIF,
        selectedDeliveryAutomaticRefresh: data.AutomaticDeliveryAdjustment,
        selectedLoadMixReleasedRefresh: data.LoadMixAllowed,
        selectedOORRelevance: data.RelevancyOOR,
        selectedSaneamentoPedidos: data.OrdersSanitation,
        selectedBreakInFullTruck: data.SuggestionsForDeliveryBreak,
        selectedNegotiateLoadCompositions: data.NegotiateLoadCompositions,
        relevanciaOORFamiliaRotulada: data.LabeledFamilyRelevancyOOR,
        numberOfDaysInAdvanceForSuggestionGeneration: data.NumberOfDaysInAdvanceForSuggestionGeneration,
        isDailyWallet: data.PeriodicityId === PERIODICIDADE_DIARIA,
        selectedAutopilotScheduleType: data.AutopilotScheduleType,
        selectedUseStorageLocations: data.UseStorageLocations,
        selectedUseDynamicInventoryPolicies: data.UseDynamicInventoryPolicies,
        selectedCurrentStockPolicy: data.InventoryPolicyModel !== null && data.InventoryPolicyModel !== undefined
          ? mapInventoryPolicyModelToStockPolicy(data.InventoryPolicyModel)
          : this._deriveStockPolicy(data),
        selectedBusinessUnitDoorId: data.BusinessUnitDoorId,
        businessUnit: businessUnitData,
        inventoryStorageLocations: mapperInventoryStorageLocations(businessUnitData?.StorageLocations, data.LabeledFamilyCenterBusinessUnitStorageLocations),
        storageLocationsProductionLines: mapperStorageLocationsProductionLines(businessUnitData?.StorageLocations, data.LabeledFamilyCenterBusinessUnitStorageLocations, productionLines)
      });

      if (this.props.editMode && data.UseDynamicInventoryPolicies) {
        const labeledFamilyCenterMaterial = await searchLabeledFamilyCenterMaterialByLabeledFamilyId(this.props.idEdit);
        let materialId = null;
        
        if (labeledFamilyCenterMaterial && 
            Array.isArray(labeledFamilyCenterMaterial) && 
            labeledFamilyCenterMaterial.length > 0) {
          materialId = labeledFamilyCenterMaterial[0].MaterialId;
        }
        
        this.searchDynamicInventoryPolicyData(data.BusinessUnitId, materialId);
      }
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  proccessErro = (e) => {
    this.setState({
      showMsg: true,
      textMsg: formatErrorMessage(e)
    });
  };

  proccessEstoqueError = mensagem => {
    this.setState({
      showMsg: true,
      textMsg: mensagem
    });
  };

  finalizeProccessEstoqueError = () => {
    this.setState({
      showMsg: false,
      textMsg: ""
    });
  };

  searchWallets = async () => {
    try {
      const data = await searchWallets()
      this.proccessData(data, "wallets")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchFamilies = async (value) => {
    try {
      const data = await searchFamilies(value)
      this.proccessData(data, "families")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchLabeledFamilies = async (value) => {
    try {
      const data = await searchLabeledFamilies(value)
      this.proccessData(data, "labeledFamilies")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchCenters = async (value) => {
    try {
      const data = await searchCenters(value)
      this.proccessData(data, "centers")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchCoordination = async () => {
    try {
      const data = await searchCoordination()
      this.proccessData(data, "coordinations")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchPeriodicidadeList = async () => {
    try {
      const data = await searchPeriodicidadeList()
      this.proccessData(data, "periodicidades")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchTipoAlgoritmoList = async () => {
    try {
      const data = await searchTipoAlgoritmoList()
      this.proccessData(data, "tiposAlgoritmo")
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchBusinessUnit = async (id) => {
    try {
      const data = await searchBusinessUnitById(id);
      const _inventories = this.mountInventories(data.StorageLocations);

      this.setState({
        businessUnit: data,
        inventoryStorageLocations: _inventories
      })
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchDynamicInventoryPolicyData = async (businessUnitId, familyId) => {
    try {
      const data = await searchDynamicInventoryPolicy(businessUnitId, familyId);

      if (!data || Object.keys(data).length === 0) {
        this.setState(prevState => ({
          labeledFamily: {
            ...prevState.labeledFamily,
            EstoqueMinimoAtual: 0,
            EstoqueMaximoAtual: 0,
            PontoReabastecimentoAtual: 0,
          },
          campoPercentual: 0,
        }));
      } else {
        // Garante que todos os valores sejam números válidos
        const estoqueMinimo = parseFloat(data.MinimumStock) || 0;
        const estoqueMaximo = parseFloat(data.MaximumStock) || 0;
        const intervalo = estoqueMaximo - estoqueMinimo;
        
        // Usa o valor do TargetStockPoint, se inválido usa o valor máximo como padrão
        const pontoReabastecimento = parseFloat(data.TargetStockPoint);
        const pontoReabastecimentoValido = !isNaN(pontoReabastecimento) ? pontoReabastecimento : estoqueMaximo;

        // Calcula o percentual garantindo que não teremos NaN
        const percentualCalculado = intervalo > 0 
          ? Math.ceil(((pontoReabastecimentoValido - estoqueMinimo) / intervalo) * 100)
          : 0;

        this.setState(prevState => ({
          labeledFamily: {
            ...prevState.labeledFamily,
            EstoqueMinimoAtual: estoqueMinimo,
            EstoqueMaximoAtual: estoqueMaximo,
            PontoReabastecimentoAtual: pontoReabastecimentoValido,
          },
          campoPercentual: percentualCalculado,
        }));
      }
    } catch (e) {
      this.proccessErro(e);
    }
  }

  searchFeatureFlagDynamicInventoryPolicy = async () => {
    try {
      const featureFlagDynamicInventoryPolicyData = await featureFlagDynamicInventoryPolicy();

      this.setState({
        featureFlagDynamicInventoryPolicy: featureFlagDynamicInventoryPolicyData,
      })
    }
    catch (e) {
      this.proccessErro(e)
    } 
  }

  _deriveStockPolicy = (data) => {
    if (data.DoiMinimum !== null && data.DoiMinimum !== undefined) return STOCK_POLICY.DAILY_DOI;
    if (data.UseDynamicInventoryPolicies) return STOCK_POLICY.WEEKLY_DOI;
    return STOCK_POLICY.OBJECTIVE;
  }

  searchFeatureFlagDoiDynamicInventoryPolicy = async () => {
    try {
      const data = await featureFlagDoiDynamicInventoryPolicy();
      this.setState({ featureFlagDoiDynamicInventoryPolicy: data });
    } catch (e) {
      this.proccessErro(e);
    }
  }

  searchSaneamentoVolumesPendentes = async (id) => {
    try {
      const data = await searchSaneamentoVolumesPendentes(id)
      if (this.state._isMounted) {
        this.setState({
          saneamentoVolumesPendentesFamiliaRotulada: data,
          selectedSaneamentoVolumesPendentes: data
        })
      }
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  searchPilotoAutomatico = async (id) => {
    try {
      const data = await searchPilotoAutomatico(id)
      if (this.state._isMounted) {
        this.setState({
          pilotoAutomaticoFamiliaRotulada: data,
          selectedPilotoAutomatico: data
        })
      }
    }
    catch (e) {
      this.proccessErro(e)
    }
  }
  searchAcionamentoTransporteCIF = async (id) => {
    try {
      const data = await searchAcionamentoTransporteCIF(id)
      if (this.state._isMounted) {
        this.setState({
          acionamentoTransporteCIFFamiliaRotulada: data,
          selectedAcionamentoTransporteCIF: data
        })
      }
    }
    catch (e) {
      this.proccessErro(e)
    }
  }

  proccessData = (data, prop) => {
    if (this.state._isMounted)
      this.setState({ [prop]: data });
  };

  changeValue = event => {
    const prop = event.target.name;
    let value = event.target.value;

    if (prop == 'HorizonteProgramacao' || prop == 'ReplanejamentoPedidosDX' || prop === 'orderSanitation') {
      value = formatOnlyNumber(value)
    }

    this.setState(prevState => ({
      labeledFamily: {
        ...prevState.labeledFamily,
        [prop]: value
      }
    }));
  };

  changeValueDecimal = (prop, value) => {
    this.setState(prevState =>
      ({
        labeledFamily: {
          ...prevState.labeledFamily,
          [prop]: value
        }
      }),
      () => {
        if (prop === "EstoqueMinimoAtual" || prop === "EstoqueMaximoAtual" || prop === "PontoReabastecimentoAtualPerc") {
          this.calculaPontoReabastecimentoAtual();
        }
      }
    );
  }

  changeDecimalValue = (prop, value) => {
    if (value) {
      value = value.toString()
      value = value.length > 3 ? value.slice(0, 3) : value
    }

    this.setState({
      campoPercentual: value
    })

    this.changeValueDecimal(prop, value)
  };

  calculaPontoReabastecimentoAtual = () => {
    const { labeledFamily, campoPercentual } = this.state;

    const estoqueMinimoAtual = parseFloatByLocale(labeledFamily.EstoqueMinimoAtual);
    const estoqueMaximoAtual = parseFloatByLocale(labeledFamily.EstoqueMaximoAtual);

    const pontoReabastecimentoAtualPerc = campoPercentual

    const intervalo = estoqueMaximoAtual - estoqueMinimoAtual;
    const pontoReabastecimentoAtual = ((Number(pontoReabastecimentoAtualPerc) / 100) * Number(intervalo)) + Number(estoqueMinimoAtual);

    this.setState(prevState => ({
      labeledFamily: {
        ...prevState.labeledFamily,
        PontoReabastecimentoAtual: !pontoReabastecimentoAtual ? estoqueMinimoAtual : pontoReabastecimentoAtual,
      },
    }));
  };

  save = () => {
    const {
      selectedLabeledFamily,
      selectedCenter,
      selectedCoordination,
      selectedPeriodicidade,
      selectedTipoAlgoritmo,
      selectedSaneamentoVolumesPendentes,
      selectedReplanejamentoDataEntrega,
      selectedCreateChargeCompositionAutomatic,
      selectedExternalSuggestion,
      selectedFutureNeed,
      selectedReschedulingOrderByCapacity,
      selectedUseHourlyPlan,
      selectedPilotoAutomatico,
      selectedAcionamentoTransporteCIF,
      selectedDeliveryAutomaticRefresh,
      selectedLoadMixReleasedRefresh,
      selectedOORRelevance,
      selectedSaneamentoPedidos,
      selectedBreakInFullTruck,
      selectedNegotiateLoadCompositions,
      campoPercentual,
      numberOfDaysInAdvanceForSuggestionGeneration,
      selectedAutopilotScheduleType,
      selectedUseStorageLocations,
      selectedCurrentStockPolicy,
      selectedBusinessUnitDoorId,
      businessUnit,
      inventoryStorageLocations,
      storageLocationsProductionLines,
    } = this.state;
    let model = this.state.labeledFamily;

    const _data = selectedUseStorageLocations ? mountLabeledFamilyCenterBusinessUnitStorageLocations(businessUnit.StorageLocations, this.props.idEdit, inventoryStorageLocations, storageLocationsProductionLines) : [];

    model = {
      FutureStockPolicyStartDate: model.DataInicioPoliticaEstoqueFuturo,
      ProgrammingHorizon: model.HorizonteProgramacao,
      ReplanningOrdersDX: model.ReplanejamentoPedidosDX,
      Destination: model.Centro,
      LabeledFamily: model.FamiliaRotulada,
      Family: model.Familia,
      MaterialGroup: model.Carteira,
      LabeledFamilyId: selectedLabeledFamily,
      BusinessUnitId: selectedCenter,
      Coordinations: selectedCoordination,
      CurrentMinimumStock: parseFloatByLocale(model.EstoqueMinimoAtual),
      CurrentMaximumStock: parseFloatByLocale(model.EstoqueMaximoAtual),
      CurrentRefuelingPoint: model.PontoReabastecimentoAtual,
      CurrentRefuelingPointPercent: parseFloatByLocale(campoPercentual),
      MinimumFutureStock: model.EstoqueMinimoFuturo
        ? parseFloatByLocale(model.EstoqueMinimoFuturo)
        : null,
      MaximumFutureStock: model.EstoqueMaximoFuturo
        ? parseFloatByLocale(model.EstoqueMaximoFuturo)
        : null,
      FutureRefuelingPointPercent: model.PontoReabastecimentoFuturoPerc
        ? parseFloatByLocale(model.PontoReabastecimentoFuturoPerc)
        : null,
      FutureRefuelingPoint: model.PontoReabastecimentoFuturo
        ? parseFloatByLocale(model.PontoReabastecimentoFuturo)
        : null,
      Id: this.props.idEdit,
      PeriodicityId: selectedPeriodicidade,
      StockPolicyTypeId: selectedTipoAlgoritmo,
      SanitationPendingVolumes: selectedSaneamentoVolumesPendentes,
      ReplanningDeliveryDate: selectedReplanejamentoDataEntrega,
      CreateAutomaticLoadComposition: selectedCreateChargeCompositionAutomatic,
      ExternalSuggestion: selectedExternalSuggestion,
      FutureNeed: selectedFutureNeed,
      ReschedulingOrderByCapacity: selectedReschedulingOrderByCapacity,
      UseHourlyPlan: selectedUseHourlyPlan,
      Autopilot: selectedPilotoAutomatico,
      TransportDriveCIF: selectedAcionamentoTransporteCIF,
      AutomaticDeliveryAdjustment: selectedDeliveryAutomaticRefresh,
      LoadMixAllowed: selectedLoadMixReleasedRefresh,
      RelevancyOOR: selectedOORRelevance,
      OrdersSanitation: selectedSaneamentoPedidos,
      SuggestionsForDeliveryBreak: selectedBreakInFullTruck,
      NegotiateLoadCompositions: selectedNegotiateLoadCompositions,
      NumberOfDaysInAdvanceForSuggestionGeneration: numberOfDaysInAdvanceForSuggestionGeneration,
      TruckSize : model.TruckSize,
      NumberOfDaysToProcessOrders: model.orderSanitation
        ? parseInt(model.orderSanitation)
        : null,
      AutopilotScheduleType: selectedAutopilotScheduleType,
      UseStorageLocations: selectedUseStorageLocations,
      UseDynamicInventoryPolicies: selectedCurrentStockPolicy !== STOCK_POLICY.OBJECTIVE,
      InventoryPolicyModel: INVENTORY_POLICY_MODEL[selectedCurrentStockPolicy] ?? 0,
      DoiMinimum: selectedCurrentStockPolicy === STOCK_POLICY.DAILY_DOI ? model.DoiMinimum : null,
      DoiTarget: selectedCurrentStockPolicy === STOCK_POLICY.DAILY_DOI ? model.DoiTarget : null,
      DoiMaximum: selectedCurrentStockPolicy === STOCK_POLICY.DAILY_DOI ? model.DoiMaximum : null,
      DoiFloor: selectedCurrentStockPolicy === STOCK_POLICY.DAILY_DOI ? model.DoiFloor : null,
      BusinessUnitDoorId: selectedBusinessUnitDoorId,
      LabeledFamilyCenterBusinessUnitStorageLocations: _data
    };

    if (this.validarInformacoesCadastro(model)) {
      this.startFetching();
      Fetch.post(`/labeled-family-centers`, model)
        .then(this.props.handleRefresh)
        .then(() =>
          this.props.handleFeedback(
            `${intl.get("feedbacks.register")} ${!this.props.editMode ? intl.get("feedbacks.saved") : intl.get("feedbacks.updated")
            } ${intl.get("feedbacks.withSuccess")}`
          )
        )
        .catch(e => this.proccessErro(e))
        .finally(() => this.stopFetching());
    }
  };

  isStorageLocationsValid = (model) => {
    if(!model.UseStorageLocations) {
      return true;
    } else if (model.UseStorageLocations && model.LabeledFamilyCenterBusinessUnitStorageLocations.length == 0) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message15"))
      return false;
    } else if (model.UseStorageLocations && !verifyAllStorageLocationsHasLines(this.state.businessUnit?.StorageLocations, model.LabeledFamilyCenterBusinessUnitStorageLocations)) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message16"))
      return false;
    } else if (verifyStoragesHasSomePolicyError(model.LabeledFamilyCenterBusinessUnitStorageLocations)) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message17"))
      return false;
    } else {
      return true;
    }
  }

  validarInformacoesCadastro = model => {
    if (!model.LabeledFamilyId) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message1"));
      return false;
    } else if (!model.BusinessUnitId) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message2"));
      return false;
    } else if (model.Coordinations.length <= 0) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message3"));
      return false;
    } else if (!model.PeriodicityId) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message18"));
      return false;
    } else if (!model.StockPolicyTypeId) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message4"));
      return false;
    } else if (validaReplanejamentosPedidosDX(model.ReplanningOrdersDX)) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message5"));
      return false;
    } else if (!model.ProgrammingHorizon) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message6"));
      return false;
    } else if (!this.validarDoiFields(model)) {
      return false;
    } else if (model.InventoryPolicyModel !== INVENTORY_POLICY_MODEL[STOCK_POLICY.DAILY_DOI] && !this.validarEstoqueEPorcentagem(model)) {
      return false;
    } else if (!this.validarPlanejamentoEPoliticas(model)) {
      return false;
    } else {
      return this.isStorageLocationsValid(model);
    }
  };

  validarEstoqueEPorcentagem = model => {
    if (model.CurrentMaximumStock < model.CurrentMinimumStock
      && model.StockPolicyTypeId != TIPO_ALGORITMO_POLITICA_SILOS) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message8"));
      return false;
    } else if (Math.ceil(model.CurrentRefuelingPointPercent) > 100) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message12"));
      return false;
    } else if ((Math.ceil(model.CurrentRefuelingPointPercent) < 0)) {
      this.proccessEstoqueError(intl.get("feedbacks.messageLabeledFamilyCenter01"))
      return false;
    } else if (!model.CurrentRefuelingPointPercent 
      && model.CurrentRefuelingPointPercent !== 0) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message13"))
      return false;
    }
    return true;
  };

  validarPlanejamentoEPoliticas = model => {
    if (model.UseHourlyPlan
      && model.ProgrammingHorizon > 15) {
      this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message14"))
      return false;
    }
    return true;
  };

  validarDoiFields = (model) => {
    if (model.InventoryPolicyModel !== INVENTORY_POLICY_MODEL[STOCK_POLICY.DAILY_DOI]) return true;
    const fields = [
      { value: model.DoiMinimum, key: 'doiMinimum' },
      { value: model.DoiTarget, key: 'doiTarget' },
      { value: model.DoiMaximum, key: 'doiMaximum' },
      { value: model.DoiFloor, key: 'doiFloor' },
    ];
    for (const field of fields) {
      if (field.value === null || field.value === undefined) {
        this.proccessEstoqueError(intl.get("master-data.general.familyLabeledCenter.feedback.message19"));
        return false;
      }
    }
    return true;
  };

  updateSelectValue = (prop, value) => {
    this.setState({
      [prop]: value
    })

    if(prop == "selectedCenter" && value) {
      this.searchBusinessUnit(value)
    }
  }

  updateSelectValueDynamicInventoryPolicy = (prop, value) => {
    this.setState({
      [prop]: value
    }, () => {
      const { selectedCenter } = this.state;
      if (value) {
        searchLabeledFamilyCenterMaterialByLabeledFamilyId(this.props.idEdit)
          .then(labeledFamilyCenterMaterial => {
            let materialId = null;
            if (labeledFamilyCenterMaterial && 
                Array.isArray(labeledFamilyCenterMaterial) && 
                labeledFamilyCenterMaterial.length > 0) {
              materialId = labeledFamilyCenterMaterial[0].MaterialId;
            }
            
            this.setState({ materialId }, () => {
              if (materialId) {
                this.searchDynamicInventoryPolicyData(selectedCenter, materialId);
              }
            });
          })
          .catch(e => this.proccessErro(e));
      }
    });
  }

  updateCurrentStockPolicy = (policy) => {
    this.setState({ selectedCurrentStockPolicy: policy });
    if (policy !== STOCK_POLICY.DAILY_DOI) {
      this.setState(prev => ({
        labeledFamily: {
          ...prev.labeledFamily,
          DoiMinimum: null,
          DoiTarget: null,
          DoiMaximum: null,
          DoiFloor: null,
        }
      }));
    }
    if (policy === STOCK_POLICY.WEEKLY_DOI) {
      this.updateSelectValueDynamicInventoryPolicy("selectedUseDynamicInventoryPolicies", true);
    } else if (policy === STOCK_POLICY.OBJECTIVE) {
      this.updateSelectValueDynamicInventoryPolicy("selectedUseDynamicInventoryPolicies", false);
    }
  }

  updateSelectValueTypeAlgorithm = (prop, value) => {
    this.setState({
      [prop]: value
    })

    this.setState(prevState => ({
      labeledFamily: {
        ...prevState.labeledFamily,
        EstoqueMinimoAtual: getValueForCondition(this.props.editMode, prevState.labeledFamily.EstoqueMinimoAtual, 0),
        EstoqueMaximoAtual: getValueForCondition(this.props.editMode, prevState.labeledFamily.EstoqueMaximoAtual, 0),
        PontoReabastecimentoAtualPerc: getValueForCondition(this.props.editMode, prevState.campoPercentual, 100),
        PontoReabastecimentoAtual: getValueForCondition(this.props.editMode, prevState.labeledFamily.PontoReabastecimentoAtual, 0)
      },
      campoPercentual: getValueForCondition(this.props.editMode, prevState.campoPercentual, 100)
    }), () => this.calculaPontoReabastecimentoAtual());
  }

  updateSelectValuePeriodicity = (prop, value) => {
    this.setState({
      [prop]: value
    });

    if (prop == "selectedPeriodicidade" && value == PERIODICIDADE_MENSAL) {
      this.setState(prevState => ({
        selectedTipoAlgoritmo: TIPO_ALGORITMO_POLITICA_OBJECTIVA,
        selectedSaneamentoVolumesPendentes: false,
        isDailyWallet: false,
        labeledFamily: {
          ...prevState.labeledFamily,
          ReplanejamentoPedidosDX: 0,
        },
      }));
    } else if (prop == "selectedPeriodicidade" && value == PERIODICIDADE_DIARIA) {
      this.setState(prevState => ({
        selectedSaneamentoVolumesPendentes: true,
        selectedCreateChargeCompositionAutomatic: false,
        isDailyWallet: true,
        labeledFamily: {
          ...prevState.labeledFamily,
        },
      }));
    }
  }

  updateCoordinationSelectValue = event => {
    this.setState({
      selectedCoordination: event
    });
  };

  updateWalletSelectedValue = (prop, value) => {
    this.setState({
      selectedWallet: value,
      selectedFamily: "",
      selectedLabeledFamily: "",
      selectedCenter: ""
    });

    if (value > 0) {
      this.searchFamilies(value);
    }
  };

  updateFamilySelectedValue = (prop, value) => {
    this.setState({
      selectedFamily: value,
      selectedLabeledFamily: "",
      selectedCenter: ""
    });

    if (value > 0) {
      this.searchLabeledFamilies(value);
    }
  };

  updateLabeledFamilySelectedValue = (prop, value) => {
    this.setState({
      selectedLabeledFamily: value,
      selectedCenter: ""
    });

    if (value > 0) {
      this.searchCenters(value);
      this.searchSaneamentoVolumesPendentes(value);
      this.searchPilotoAutomatico(value);
      this.searchAcionamentoTransporteCIF(value);
    }
  };

  updateStorageLocations = (key, value) => {
    this.setState(prevState => ({
      storageLocationsProductionLines: {
        ...prevState.storageLocationsProductionLines,
        [key]: value
      }
    }))
  }

  updateStorageLocationsInventory = (key, prop, value) => {
    const { inventoryStorageLocations } = this.state;
    const { editMode } = this.props;

    if (prop == 'CurrentRefuelingPointPercent' && value) {
      value = value.toString();
      value = value.length > 3 ? value.slice(0, 3) : value;
    } else if(!value) value = 0;

    const _inventory = inventoryStorageLocations;
    const index = _inventory.findIndex(x => x.StorageLocationId == key);
    let _item = {
      ..._inventory[index],
      [prop]: value
    };

    if (["CurrentMinimumStock", "CurrentMaximumStock", "CurrentRefuelingPointPercent"].includes(prop)) {
      const estoqueMinimoAtual = parseFloatByLocale(_item.CurrentMinimumStock);
      const estoqueMaximoAtual = parseFloatByLocale(_item.CurrentMaximumStock);
      const pontoReabastecimentoAtualPerc = !_item.CurrentRefuelingPointPercent && !editMode ? 100
      : parseFloatByLocale(_item.CurrentRefuelingPointPercent)
      const intervalo = estoqueMaximoAtual - estoqueMinimoAtual;

      const pontoReabastecimentoAtual = ((Number(pontoReabastecimentoAtualPerc) / 100) * Number(intervalo)) + Number(estoqueMinimoAtual);

      _item = {
        ..._item,
        CurrentRefuelingPoint: !pontoReabastecimentoAtual ? estoqueMinimoAtual : pontoReabastecimentoAtual,
        CurrentRefuelingPointPercent: pontoReabastecimentoAtualPerc
      };
    }

    _inventory.splice(index, 1, _item);

    this.setState({
      inventoryStorageLocations: _inventory
    });
  }

  montarMensagemDivergenciaFamiliaRotulada = () => {
    if (!hideSomeSettingsLabeledFamily()) {
      return (
        <span className="span-message">
          {intl.get(`${INTL_GERAL}.optionDiffersLabeledFamily`)}
        </span>
      );
    }
    return null;
  }

  verificarSaneamentoDeVolume = () => {
    const {
      selectedPeriodicidade,
      saneamentoVolumesPendentesFamiliaRotulada,
      selectedSaneamentoVolumesPendentes
    } = this.state

    return (selectedPeriodicidade == PERIODICIDADE_DIARIA && saneamentoVolumesPendentesFamiliaRotulada != selectedSaneamentoVolumesPendentes)
  }

  montarToogle = (name, label, value, changeProp, disabled) => {
    const style = {
      labelStyle: {
        color: 'var(--color-contrast-black)'
      },
      thumbSwitched: {
        backgroundColor: 'var(--color-action-default)',
      },
      trackSwitched: {
        backgroundColor: 'var(--color-neutral-200)',
      },
    }

    return (
      <ToggleTwo
        name={name}
        label={label}
        value={value}
        onChange={val => this.updateSelectValue(changeProp, val.checked)}
        thumbSwitchedStyle={style.thumbSwitched}
        trackSwitchedStyle={style.trackSwitched}
        labelStyle={style.labelStyle}
        labelPosition={"right"}
        disabled={disabled}
      />
    )
  }

  obterTitulo(editMode) {
    return editMode ? intl.get('master-data.general.actions.updateRotuledFamily') : intl.get('master-data.general.actions.newRotuledFamily');
  }

  renderTmsConfiguration(
    selectedAcionamentoTransporteCIF,
    selectedLabeledFamily,
    acionamentoTransporteCIFFamiliaRotulada
  ) {
    return <Fragment>
      <label className="label-style">{intl.get(`${INTL_GERAL}.tmsConfiguration`)}</label>
      <div className="container__general-form">
        <Row>
          <Col xs={6} lg={6} md={6}>
            <Switcher
              name="AcionamentoTransporteCIF"
              label={intl.get(`${INTL_GERAL}.triggerTransportCif`)}
              value={selectedAcionamentoTransporteCIF}
              onChange={val => this.updateSelectValue("selectedAcionamentoTransporteCIF", val.checked)}
            />
            {selectedLabeledFamily && acionamentoTransporteCIFFamiliaRotulada !== selectedAcionamentoTransporteCIF && (
              this.montarMensagemDivergenciaFamiliaRotulada()
            )}
          </Col>
        </Row>
      </div>
    </Fragment>
  }

  renderGeneralSettings() {
    const {
      isDailyWallet,
      selectedExternalSuggestion,
      selectedFutureNeed,
      selectedReschedulingOrderByCapacity,
      selectedOORRelevance,
      selectedUseHourlyPlan,
      selectedBreakInFullTruck,
      selectedLoadMixReleasedRefresh,
      selectedNegotiateLoadCompositions,
      selectedReplanejamentoDataEntrega,
    } = this.state;

    return <Fragment>
      <label className="label-style">
        <span>
          {intl.get(`${INTL_GERAL}.generalSettings`)}
        </span>
      </label>

      <div className="container__general-form">
        <Row>
          {/*Flag de Sugestão Externa ocultada, posteriormente deve ser removida ao remover campo da tabela de FRC*/}
          <Feature validation={false}>
            <Col xs={4} lg={4} md={4} className="bulk-pending">
              <SwitcherTwo
                name="SugestaoExterna"
                label={intl.get(`${INTL_GERAL}.externalSuggestions`)}
                value={selectedExternalSuggestion}
                onChange={(value) => this.updateSelectValue("selectedExternalSuggestion", value.checked)}
              />
            </Col>
          </Feature>
          <Col xs={4} lg={4} md={4} className="bulk-pending">
            {this.montarToogle(
              "NecessidadeFutura",
              intl.get(`${INTL_GERAL}.futureNeed`),
              selectedFutureNeed,
              "selectedFutureNeed",
            )}
          </Col>
          {usesOORRelevance() &&
            <Col xs={4} lg={4} md={4}>
              <SwitcherTwo
                name="RelevanciaOOR"
                label={intl.get(`${INTL_GERAL}.relevanceOOR`)}
                value={selectedOORRelevance}
                onChange={(value) => this.updateSelectValue("selectedOORRelevance", value.checked)}
              />
            </Col>
          }
          {isDailyWallet &&
            <Col xs={4} lg={4} md={4} className="bulk-pending">
              <SwitcherTwo
                name="ReschedulingOrderByCapacity"
                label={intl.get(`${INTL_GERAL}.reschedulingOrderByCapacity`)}
                value={selectedReschedulingOrderByCapacity}
                onChange={(value) => this.updateSelectValue("selectedReschedulingOrderByCapacity", value.checked)}
              />

            </Col>
          }
          {usesHourlyPlan() &&
            <Col xs={4} lg={4} md={4} className="bulk-pending">
              <SwitcherTwo
                name="UseHourlyPlan"
                label={intl.get(`${INTL_GERAL}.useHourlyPlan`)}
                value={selectedUseHourlyPlan}
                onChange={(value) => this.updateSelectValue("selectedUseHourlyPlan", value.checked)}
              />
            </Col>
          }
          <Col xs={4} lg={4} md={4} className="bulk-pending">
            <SwitcherTwo
              name="BreakInFullTruck"
              label={intl.get(`${INTL_GERAL}.breakInFullTruck`)}
              value={selectedBreakInFullTruck}
              onChange={(value) => this.updateSelectValue("selectedBreakInFullTruck", value.checked)}
            />
          </Col>
          {usesVolume() &&
            <Col xs={4} lg={4} md={4}>
              <SwitcherTwo
                name="MixCargaLiberado"
                label={intl.get(`${INTL_GERAL}.loadMixReleased`)}
                value={selectedLoadMixReleasedRefresh}
                onChange={val => this.updateSelectValue("selectedLoadMixReleasedRefresh", val.checked)}
              />
            </Col>
          }
          {isDailyWallet &&
            <Col xs={4} lg={4} md={4} className="bulk-pending">
              <SwitcherTwo
                name="NegotiateLoadCompositions"
                label={intl.get(`${INTL_GERAL}.negotiateLoadCompositions`)}
                value={selectedNegotiateLoadCompositions}
                onChange={(value) => this.updateSelectValue("selectedNegotiateLoadCompositions", value.checked)}
              />
            </Col>
          }
          <Col xs={4} lg={4} md={4} className="bulk-pending">
            <SwitcherTwo
              name="ReplanejamentoDataEntrega"
              label={intl.get(`${INTL_GERAL}.deliveryDateReplanning`)}
              value={selectedReplanejamentoDataEntrega}
              onChange={(value) => this.updateSelectValue("selectedReplanejamentoDataEntrega", value.checked)}
            />
          </Col>
        </Row>
      </div>
    </Fragment>
  }

  defineTipoAlgoritmoOptions(tiposAlgoritmo) {
    return tiposAlgoritmo.filter(x => x.Id !== TIPO_ALGORITMO_POLITICA_SILOS)
  }

  defineTipoAlgoritmoDisabled(selectedPeriodicidade) {
    return selectedPeriodicidade !== 2;
  }

  render() {
    const {
      labeledFamily,
      wallets,
      families,
      labeledFamilies,
      centers,
      coordinations,
      isFetching,
      selectedWallet,
      selectedFamily,
      selectedLabeledFamily,
      selectedCenter,
      selectedCoordination,
      selectedPeriodicidade,
      selectedSaneamentoVolumesPendentes,
      selectedCreateChargeCompositionAutomatic,
      selectedSaneamentoPedidos,
      selectedAcionamentoTransporteCIF,
      periodicidades,
      selectedTipoAlgoritmo,
      tiposAlgoritmo,
      showMsg,
      textMsg,
      idPeriodicidadeFamiliaRotulada,
      acionamentoTransporteCIFFamiliaRotulada,
      isDailyWallet,
      campoPercentual,
      selectedUseStorageLocations,
      storageLocationsProductionLines,
      selectedCurrentStockPolicy,
    } = this.state

    const { open, editMode, handleClose } = this.props;
    return (
      <Fragment>
        <Loading isLoading={isFetching} />
        <GenericModal
          open={open}
          onRequestClose={handleClose}
          modalStyle={{ width: '90%', maxWidth: '1200px', maxHeight: '90vh', overflowY: 'auto' }}
        >
          <StyledForm>
            <div className="modal-header">
              <h2 className="modal-title">{this.obterTitulo(editMode)}</h2>
            </div>
            <div className="modal-content">
            {/* Row 1: 5 identificadores em uma linha */}
            <Row>
              <Col xs={2} md={2} lg={2}>
                {!editMode ? (
                  <SelectBox
                    required
                    name="Carteira"
                    className="carteira"
                    label={intl.get(`${INTL_GERAL}.wallet`)}
                    placeholder={intl.get(`${INTL_GERAL}.wallet`)}
                    valueKey="Id"
                    labelKey="Description"
                    value={selectedWallet}
                    options={wallets}
                    onChange={value => this.updateWalletSelectedValue("Carteira", value.Id)}
                    searchable
                    openOnFocus
                  />
                ) : (
                  <Input disabled label={intl.get(`${INTL_GERAL}.wallet`)} name="Carteira" value={labeledFamily.Carteira} className="input" />
                )}
              </Col>
              <Col xs={2} md={2} lg={2}>
                {!editMode ? (
                  <SelectBox
                    required
                    name="Familia"
                    className="familia"
                    label={intl.get(`${INTL_GERAL}.family`)}
                    placeholder={intl.get(`${INTL_GERAL}.family`)}
                    valueKey="Id"
                    labelKey="Name"
                    value={selectedFamily}
                    options={families}
                    onChange={value => this.updateFamilySelectedValue("Carteira", value.Id)}
                    searchable
                    openOnFocus
                  />
                ) : (
                  <Input disabled label={intl.get(`${INTL_GERAL}.family`)} name="Familia" value={labeledFamily.Familia} className="input" />
                )}
              </Col>
              <Col xs={2} md={2} lg={2}>
                {!editMode ? (
                  <SelectBox
                    required
                    name="FamiliaRotulada"
                    className="familiaRotulada"
                    label={intl.get(`${INTL_GERAL}.labeledFamily`)}
                    placeholder={intl.get(`${INTL_GERAL}.labeledFamily`)}
                    valueKey="Id"
                    labelKey="Description"
                    value={selectedLabeledFamily}
                    options={labeledFamilies}
                    onChange={value => this.updateLabeledFamilySelectedValue("FamiliaRotulada", value.Id)}
                    searchable
                    openOnFocus
                  />
                ) : (
                  <Input disabled label={intl.get(`${INTL_GERAL}.labeledFamily`)} name="FamiliaRotulada" value={labeledFamily.FamiliaRotulada} className="input" />
                )}
              </Col>
              <Col xs={2} md={2} lg={2}>
                {!editMode ? (
                  <SelectBox
                    required
                    name="Centro"
                    className="centro"
                    label={intl.get(`${INTL_GERAL}.center`)}
                    placeholder={intl.get(`${INTL_GERAL}.center`)}
                    valueKey="Id"
                    labelKey="Nome"
                    value={selectedCenter}
                    options={centers}
                    onChange={value => this.updateSelectValue("selectedCenter", value.Id)}
                    searchable
                    openOnFocus
                  />
                ) : (
                  <Input disabled label={intl.get(`${INTL_GERAL}.center`)} name="Centro" value={labeledFamily.Centro} className="input" />
                )}
              </Col>
              <Col xs={4} md={4} lg={4}>
                <SelectBox
                  required
                  name="Coordenacao"
                  className="coordenacao"
                  label={intl.get(`${INTL_GERAL}.coordination`)}
                  placeholder={intl.get(`${INTL_GERAL}.coordination`)}
                  valueKey="Id"
                  labelKey="Description"
                  value={selectedCoordination}
                  options={coordinations}
                  onChange={this.updateCoordinationSelectValue}
                  searchable
                  openOnFocus
                  multi
                />
              </Col>
            </Row>

            {/* Row 2: Periodicidade + TipoAlgoritmo + HP + configs diárias/mensais inline */}
            <Row className="row-box" style={{ alignItems: 'flex-end' }}>
              <Col xs={2} md={2} lg={2}>
                <div className="auto-complete">
                  <SelectBox
                    required
                    name="Periodicidade"
                    className="periodicidade"
                    label={intl.get(`${INTL_GERAL}.frequency`)}
                    placeholder={intl.get(`${INTL_GERAL}.frequency`)}
                    valueKey="Id"
                    labelKey="Name"
                    value={selectedPeriodicidade}
                    options={periodicidades}
                    onChange={value => this.updateSelectValuePeriodicity("selectedPeriodicidade", value.Id)}
                    searchable
                    openOnFocus
                  />
                  {idPeriodicidadeFamiliaRotulada != selectedPeriodicidade && !hideSomeSettingsLabeledFamily() && (
                    <div className='span-message-container'>
                      {this.montarMensagemDivergenciaFamiliaRotulada()}
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <div className="auto-complete">
                  <SelectBox
                    disabled={this.defineTipoAlgoritmoDisabled(selectedPeriodicidade)}
                    required
                    name="TipoAlgoritmo"
                    className="tipoAlgoritmo"
                    label={intl.get(`${INTL_GERAL}.typeAlgorithm`)}
                    placeholder=""
                    valueKey="Id"
                    labelKey="Description"
                    value={selectedTipoAlgoritmo}
                    options={this.defineTipoAlgoritmoOptions(tiposAlgoritmo)}
                    onChange={value => this.updateSelectValueTypeAlgorithm("selectedTipoAlgoritmo", value.Id)}
                    searchable
                    openOnFocus
                  />
                </div>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <div className="auto-complete">
                  <Input
                    required
                    label={intl.get(`${INTL_GERAL}.programmingHorizon`)}
                    name="HorizonteProgramacao"
                    value={labeledFamily.HorizonteProgramacao}
                    onChange={this.changeValue}
                    className="input"
                  />
                </div>
              </Col>
              { isDailyWallet && (
                <>
                  <Col xs={2} md={2} lg={2}>
                    <div className="auto-complete">
                      <Input
                        label={intl.get(`${INTL_GERAL}.orderGridReplanning`)}
                        name="ReplanejamentoPedidosDX"
                        value={labeledFamily.ReplanejamentoPedidosDX}
                        onChange={this.changeValue}
                        className='input-dx input'
                      />
                    </div>
                  </Col>
                  {usesTmsIntegration() && (
                    <>
                      <Col xs={2} md={2} lg={2} className="bulk-pending" style={{ paddingTop: '8px' }}>
                        <div className="auto-complete">
                          <SwitcherTwo
                            name="SaneamentoVolumesPendentes"
                            label={intl.get(`${INTL_GERAL}.cleanseBulkPending`)}
                            value={selectedSaneamentoVolumesPendentes}
                            onChange={(value) => this.updateSelectValue("selectedSaneamentoVolumesPendentes", value.checked)}
                          />
                        </div>
                        {this.verificarSaneamentoDeVolume() && (this.montarMensagemDivergenciaFamiliaRotulada())}
                      </Col>
                      <Col xs={2} md={2} lg={2} className="bulk-pending" style={{ paddingTop: '8px' }}>
                        <div className="auto-complete">
                          <SwitcherTwo
                            className="SaneamentoPedidos"
                            name="SaneamentoPedidos"
                            label={intl.get(`${INTL_GERAL}.orderCleaning`)}
                            value={selectedSaneamentoPedidos}
                            onChange={(value) => this.updateSelectValue("selectedSaneamentoPedidos", value.checked)}
                          />
                        </div>
                      </Col>
                    </>
                  )}
                </>
              )}
              {!isDailyWallet && (
                <Col xs={4} md={4} lg={4} style={{ paddingTop: '8px' }}>
                  <div className="auto-complete">
                    <SwitcherTwo
                      name="CriarComposicaoDeCargaAutomatica"
                      label={intl.get(`${INTL_GERAL}.acceptChargeCompositionAutomatic`)}
                      value={selectedCreateChargeCompositionAutomatic}
                      onChange={(value) => this.updateSelectValue("selectedCreateChargeCompositionAutomatic", value.checked)}
                    />
                  </div>
                </Col>
              )}
            </Row>

            {/* Order Sanitation input (apenas quando TMS + daily + saneamentoPedidos) */}
            {usesTmsIntegration() && isDailyWallet && selectedSaneamentoPedidos && (
              <Row className="row-box">
                <Col xs={4} lg={4} md={4}>
                  <Input
                    label={intl.get(`${INTL_GERAL}.orderCleaning`)}
                    name="orderSanitation"
                    value={labeledFamily.orderSanitation}
                    onChange={this.changeValue}
                    className='input-order-sanitation input'
                  />
                  <legend className='input-legend'>{intl.get(`${INTL_GERAL}.onlyIntegerNumbers`)}</legend>
                </Col>
              </Row>
            )}

            {!selectedUseStorageLocations &&
              <InventoryConfiguration
                labeledFamily={labeledFamily}
                userCanEditStockPolicies={this.userCanEditStockPolicies}
                selectedTipoAlgoritmo={selectedTipoAlgoritmo}
                campoPercentual={campoPercentual}
                changeValueDecimal={this.changeValueDecimal}
                changeDecimalValue={this.changeDecimalValue}
                selectedCurrentStockPolicy={this.state.selectedCurrentStockPolicy}
                onStockPolicyChange={this.updateCurrentStockPolicy}
                featureFlagDynamicInventoryPolicies={this.state.featureFlagDynamicInventoryPolicy}
                featureFlagDoiDynamicInventoryPolicy={this.state.featureFlagDoiDynamicInventoryPolicy}
                doiMinimum={labeledFamily.DoiMinimum}
                doiTarget={labeledFamily.DoiTarget}
                doiMaximum={labeledFamily.DoiMaximum}
                doiFloor={labeledFamily.DoiFloor}
                onChangeDoiField={this.changeValueDecimal}
                selectedUseStorageLocations={selectedUseStorageLocations}
              />
            }

            <label className="label-style">
              <span>
                {intl.get(`${INTL_GERAL}.storageLocationSettings`)}
              </span>
            </label>
            <div className="container__general-form">
              <Row>
                <Col xs={12} lg={12} md={12}>
                  <SwitcherTwo
                    name="UseStorageLocations"
                    label={intl.get(`${INTL_GERAL}.useStorageLocations`)}
                    value={selectedUseStorageLocations}
                    onChange={(value) => this.updateSelectValue("selectedUseStorageLocations", value.checked)}
                    disabled={selectedCurrentStockPolicy !== STOCK_POLICY.OBJECTIVE}
                    title={
                      selectedCurrentStockPolicy !== STOCK_POLICY.OBJECTIVE
                        ? intl.get(`${INTL_GERAL}.useStorageLocationsDisabledByDynamicInventoryPolicies`)
                        : intl.get(`${INTL_GERAL}.useStorageLocationsHint`)
                    }
                  />
                </Col>
              </Row>
            </div>

            {this.state.selectedUseStorageLocations &&
              <StorageLocationAndLineConfiguration
                useStorageLocations={selectedUseStorageLocations}
                businessUnitData={this.state.businessUnit}
                updateStorageLocations={this.updateStorageLocations}
                storageLocationsProductionLines={storageLocationsProductionLines}
              />
            }

            {selectedUseStorageLocations && 
              <InventoryConfigurationByStorageLocation
                businessUnitData={this.state.businessUnit}
                inventoryStorageLocations={this.state.inventoryStorageLocations}
                selectedTipoAlgoritmo={selectedTipoAlgoritmo}
                updateStorageLocationsInventory={this.updateStorageLocationsInventory}
              />
            }
            
            {usesTmsIntegration() && isDailyWallet &&
              this.renderTmsConfiguration(
                selectedAcionamentoTransporteCIF,
                selectedLabeledFamily,
                acionamentoTransporteCIFFamiliaRotulada
              )
            }
            {this.renderGeneralSettings()}
            </div>
            <div className="modal-footer">
              <Button
                className="button-footer"
                buttonType="tertiary"
                value={intl.get("geral.buttonsDefault.cancel")}
                onClick={handleClose}
                data-testid="btn-cancel"
              />
              <Button
                className="button-footer"
                buttonType="primary"
                value={intl.get("geral.buttonsDefault.save")}
                onClick={this.save}
                data-testid="btn-save"
              />
            </div>
          </StyledForm>
        </GenericModal>

        <SnackBar
          message={textMsg}
          open={showMsg}
          autoHideDuration={3000}
          onRequestClose={this.finalizeProccessEstoqueError}
        />
      </Fragment>
    )
  }
}

GeneralForm.propTypes = {
  idEdit: PropTypes.number,
  open: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired
};

export default GeneralForm;
